import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { H2 } from 'foundations-components/transitional/components/H2';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useContentCrmObject from '../hooks/useContentCrmObject';
import { useMemo } from 'react';
import { PublishTypes } from '../../../constants/PublishTypes';
import { CONTENT_PLATFORM_PROPERTY_NAME, getContentPropertyValue } from 'content-management-data-lib';

/**
 * This modal is configured to be only used by ContentTypes on CMP platform
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublishConfirmModal = ({
  publishButtonTextKey,
  confirmPublishActionProps: {
    publishConfirmModalBodyContent,
    publishConfirmDisabled,
    publishConfirmDisabledTooltip
  },
  publish,
  schedulePublishUnpublish,
  closeModal
}) => {
  const {
    contentCrmObjectPublishType,
    contentCrmObject
  } = useContentCrmObject();
  const publishConfirmHeader = useMemo(() => {
    switch (contentCrmObjectPublishType) {
      case 'schedule':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publishConfirmModal.header.schedule"
        });
      case 'update':
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publishConfirmModal.header.update"
        });
      default:
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publishConfirmModal.header.publish"
        });
    }
  }, [contentCrmObjectPublishType]);
  const handleConfirmButtonClick = () => {
    if (contentCrmObjectPublishType === PublishTypes.schedule && schedulePublishUnpublish && contentCrmObject) {
      schedulePublishUnpublish({
        schedulePublishDate: getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_PUBLISH_DATE)
      });
    } else {
      publish(contentCrmObjectPublishType);
    }
    closeModal();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    width: 550,
    "data-selenium": "confirm-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: closeModal
      }), /*#__PURE__*/_jsx(H2, {
        children: publishConfirmHeader
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: publishConfirmModalBodyContent
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(Tooltip, {
          disabled: !publishConfirmDisabled,
          title: publishConfirmDisabledTooltip,
          children: /*#__PURE__*/_jsx(Button, {
            "data-test-id": "publish-confirm-button",
            "data-onboarding": "publish-confirm-button",
            use: "primary",
            disabled: publishConfirmDisabled,
            onClick: handleConfirmButtonClick,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: publishButtonTextKey
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          "data-test-id": "publish-confirm-secondary-button",
          use: "secondary",
          onClick: closeModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "publishConfirmModal.footer.cancel"
          })
        })]
      })
    })]
  });
};
export default PublishConfirmModal;